import React, { useState, ChangeEvent } from 'react'
import { Title, Description, FurtherDesc } from '../common/System'
import Arrow from '../../img/arrow.webp'
import LoadInView from '../common/LoadInView'

interface propsType {
  opt: string,
  handleOptionChange: (e: ChangeEvent<HTMLSelectElement>) => void,
  handleFileChange: (e: ChangeEvent<HTMLInputElement>) => void,
  submitHandler: (e: React.FormEvent<HTMLFormElement>) => void
}

const Upload = (props: propsType) => {
  const [show, setShow] = useState(false)
  const handleShow = () => {
    if (show) {
        setShow(false)
    } else {
        setShow(true)
    }
  }

  return (
    <>
      <Title>데이터베이스 업데이트</Title>
      <Description>
        <div>학문프로파일, 학과분류체계, 진단문항 업데이트를 위한 도구입니다. 엑셀파일을 업로드하세요.</div>
        <div>엑셀파일은 한 시트로 구성되어 있어야 합니다.</div>
      </Description>
      <FurtherDesc isShow={show}>
        <div onClick={handleShow}>
          <img src={Arrow} alt="arrow"/>
          상세 절차보기
        </div>
        {show?
          <LoadInView>
            <ol type="1">
              <li>엑셀 파일 선택</li>
              <li>선택된 엑셀파일을 DB에서 읽어냄</li>
              <li>학과분류체계인지, 학문프로파일인지 식별</li>
              <li>기존 데이터베이스를 전부 지우고, 업로드된 엑셀 기준으로 데이터를 작성함</li>
            </ol>
          </LoadInView>
          : <div></div>
        }
      </FurtherDesc>
      {/* <FlexWrapper>
        <select name="upload" onChange={(e) => props.handleOptionChange(e)}>
          <option value="">선택하기</option>
          <option value="학문프로파일">학문프로파일</option>
          <option value="학과분류체계">학과분류체계</option>
          <option value="진단문항">진단문항</option>
        </select>
        {props.opt === '학문프로파일'?
          <div>학문프로파일 데이터를 업로드합니다.</div> : <div></div>
        }
        {props.opt === '학과분류체계'?
          <div>학과분류체계 데이터를 업로드합니다.</div> : <div></div>
        }
        {props.opt === '진단문항'?
          <div>진단문항 데이터를 업로드합니다.</div> : <div></div>
        }
        <div></div>
      </FlexWrapper> */}
      <form method="post" onSubmit={(e) => props.submitHandler(e)}>
        <input type="file" id="file" name="file" onChange={(e) => props.handleFileChange(e)} />
        <button type="submit">Upload</button>
      </form>
    </>
  )
}

export default Upload

// const FlexWrapper = styled.div`
//   display: flex;
//   margin-bottom: 20px;

//   div {
//     margin-left: 10px;
//   }
// `